import { LocationBreadcrumbs } from "@/components/common/location-breadcrumbs";
import type { SearchHookLocation } from "@repo/maps";
import { useTranslations } from "next-intl";

export type AgentListBreadcrumbsProps = {
  countryCode?: string;
  location?: SearchHookLocation;
};

export function AgentListBreadcrumbs({
  countryCode,
  location,
}: AgentListBreadcrumbsProps) {
  const t = useTranslations();

  if (!location) {
    return null;
  }

  return (
    <LocationBreadcrumbs
      countryCode={countryCode}
      location={location}
      basePath="/business-brokers/"
      initialItems={[
        {
          name: t("saas.agentSearch.breadcrumbs.brokers"),
          pathSegment: "/business-brokers",
        },
      ]}
    />
  );
}

AgentListBreadcrumbs.displayName = "AgentListBreadcrumbs";
